import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  OtoIndividualPlaceListItem,
  OtoIndividualPlacesFilter
} from '../../lib/types/models/journey-place/oto-individual-place'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

// the lieux d'arrivée, optionally narrowed to one lieu de séjour
export function getAllOtoIndividualPlaces(
  input: PaginationRequest<OtoIndividualPlacesFilter> = {}
) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest<OtoIndividualPlacesFilter>>(
        constructApiUrl(API.journeyPlaces.getAllOtoIndividualPlaces.url, null),
        input
      )
    )
    .get<PaginationResponse<OtoIndividualPlaceListItem>>()
}
